export default "__VITE_ASSET__z$OxJXEr__"